import React, { memo, useEffect, useMemo } from 'react';
import VideoElement from './videoElement';
import { useSelector } from 'react-redux';
import { AttendeeName, Avatar } from '../../common';
import FrameRateIndicator from './FrameRateIndicator'

import { getMirrorClass, getParticipantBlockStatus, isTrackStreamingStatusActive, setActiveExcludingYourselfParticipant, setActiveSmallWindowParticipant, setActiveTracks } from '../../../utils/functions';

function ActiveSpeakerExcluding({ largeWindow, showActiveWindow }) {
  const videoContainerSettings = useSelector(
    state => state.conf.videoContainerSettings,
  );
  const activeParticipant = useSelector(state => state.conf.activeParticipant);
  const audioMode = useSelector(state => state.conf.audioMode);
  const trackStreamStatus = useSelector(state => state.conf.trackStreamStatus);
  const recentUnmutedUsers = useSelector(
    state => state.conf.recentUnmutedUsers,
  );
  const dominantSpeaker = useSelector(state => state.conf.dominantSpeaker);
  const screenDimension = useSelector(state => state.conf.screenDimension);
  const show_fps_in_recording = useSelector(state => state.conf.roomDetail?.show_fps_in_recording);

  const { height, width } = screenDimension;
  const currentActiveVideoTracks = useSelector(
    state => state.conf.currentActiveVideoTracks,
  );
  const activeVideoParticipantIds = useSelector(
    state => state.conf.activeVideoParticipantIds,
  );
  const refreshVideoView = useSelector(state => state.conf.refreshVideoView);
  const screenSharedJid = useSelector(state => state.conf.screenSharedJid);
  const videoTrack = activeParticipant?.track;
  let darkBackground = videoTrack ? '' : 'darkGrey';
  const unmutedParticipantIds = useSelector(
    state => state.conf.unmutedParticipantIds,
  );

  useEffect(() => {
    if (showActiveWindow) {
      setActiveSmallWindowParticipant();
    } else {
      setActiveExcludingYourselfParticipant();
    }

  }, [
    dominantSpeaker,
    videoContainerSettings?.hide_muted_attendees,
    recentUnmutedUsers,
    showActiveWindow,
    activeVideoParticipantIds,
    unmutedParticipantIds,
    audioMode,
    refreshVideoView,
    screenSharedJid,
  ]);

  useEffect(() => {
    setActiveTracks(currentActiveVideoTracks);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentActiveVideoTracks]);

  let isActive = useMemo(() => {
    return isTrackStreamingStatusActive(videoTrack?.jitsiTrack) && !audioMode;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoTrack, trackStreamStatus, audioMode]);


  let isBlocked = useMemo(() => {
    return getParticipantBlockStatus(activeParticipant);
  }, [activeParticipant]);

  const mirrorClass = getMirrorClass(activeParticipant?.jid);

  return (
    <>
      {videoContainerSettings?.hide_muted_attendees ? (
        <>
          {activeParticipant.audio === true ? (
            <div className={`videoBlock videoSpeaker ${darkBackground} `} style={largeWindow ? { width: `${width}px`, height: `${height}px` } : {}}>
              <div className="videoBlockInner">
                {videoTrack !== null && isActive && !isBlocked ? (
                  <>
                    <VideoElement track={videoTrack.jitsiTrack} className={mirrorClass} />

                    {/* When video is visible */}
                    <AttendeeName name={activeParticipant?.name} />
                    {
                      show_fps_in_recording && <FrameRateIndicator participantJid={activeParticipant?.jid} />
                    }
                    {/* When video is off */}
                  </>
                ) : (
                  <>
                    <Avatar
                      participant={activeParticipant}
                      showWarning={!isActive}
                      isBlocked={isBlocked}
                    />
                  </>
                )}
              </div>
            </div>
          ) : (
            <span className={`text-black stand-by ${!largeWindow ? 'small-view' : ''}`}>
              Please stand by until someone else is unmuted.
            </span>
          )}
        </>
      ) : (
        <>
          {/* <div className={`videoBlock videoSpeaker  ${largeWindow ? 'single-user-view' : ''} ${darkBackground}`} > */}
          {activeParticipant?.name ? (
            <div className={`videoBlock videoSpeaker  ${darkBackground}`} style={largeWindow ? { width: `${width}px`, height: `${height}px` } : {}}>
              <div className="videoBlockInner">
                {videoTrack !== null && isActive && !isBlocked ? (
                  <>
                    <VideoElement track={videoTrack.jitsiTrack} className={mirrorClass} />

                    {/* When video is visible */}
                    <AttendeeName name={activeParticipant?.name} />
                    {
                      show_fps_in_recording && <FrameRateIndicator participantJid={activeParticipant?.jid} />
                    }
                    {/* When video is off */}
                  </>
                ) : (
                  <>
                    <Avatar
                      participant={activeParticipant}
                      showWarning={!isActive}
                      isBlocked={isBlocked}
                    />
                  </>
                )}
              </div>
            </div>
          ) : (
            <span className={`text-black stand-by ${!largeWindow ? 'small-view' : ''}`}>
              Please stand by until someone else is unmuted.
            </span>
          )}
        </>
      )}
    </>
  );
}

export default memo(ActiveSpeakerExcluding);
